import { motion } from "framer-motion";
import { useState } from "react";
import axios from "axios";
import "./ContactUsPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function ContactUsPage() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    try {

      setLoading(true);

      const response = await axios.post(
        `${API_BASE_URL}/alumni/contact`,
        formData
      );

      alert(
        "Your message has been sent successfully. A confirmation email has been sent to you. An executive member will contact you soon."
      );

      setFormData({
        name: "",
        email: "",
        message: ""
      });

    } catch (error) {

      console.error("Error sending message:", error);

      const errorMessage =
        error?.response?.data?.error ||
        "Failed to send message. Please try again later.";

      alert(errorMessage);

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">

      {/* ================= Hero Section ================= */}
      <motion.section
        className="contact-hero"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1>Contact Us</h1>
        <p>We’re here to help. Reach out to us anytime.</p>
      </motion.section>

      {/* ================= Contact Info Section ================= */}
      <section className="contact-info-section">
        <div className="contact-cards-grid">

          <motion.div
            className="contact-card"
            whileHover={{ y: -6, boxShadow: "0 12px 25px rgba(0,0,0,0.12)" }}
            transition={{ duration: 0.3 }}
          >
            <h4>Office Address</h4>
            <p>
              Liberia - 1st Floor Sekou House Capitol Bye Pass Adjacent BMC Stores
            </p>
          </motion.div>

          <motion.div
            className="contact-card"
            whileHover={{ y: -6, boxShadow: "0 12px 25px rgba(0,0,0,0.12)" }}
            transition={{ duration: 0.3 }}
          >
            <h4>Email</h4>
            <p>info@ugaaliberia.org</p>
            <p>secretary@ugaaliberia.org</p>
            <p>president@ugaaliberia.org</p>
          </motion.div>

          <motion.div
            className="contact-card"
            whileHover={{ y: -6, boxShadow: "0 12px 25px rgba(0,0,0,0.12)" }}
            transition={{ duration: 0.3 }}
          >
            <h4>Phone</h4>
            <p>+231 881 924 553</p>
            <p>+231 777 777 510</p>
          </motion.div>

        </div>
      </section>

      {/* ================= Contact Form ================= */}
      <motion.section
        className="contact-form-section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h2>Send Us a Message</h2>

        <form className="contact-form" onSubmit={handleSubmit}>

          <label>
            Name
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Email
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Message
            <textarea
              name="message"
              placeholder="Your message here..."
              value={formData.message}
              onChange={handleChange}
              required
            />
          </label>

          <button
            type="submit"
            className="btn primary"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>

        </form>
      </motion.section>

    </div>
  );
}